import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toggleSidebar } from "../../store/actions/layout";

const Job = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { isSidebarOpened } = useSelector((state) => state.layout);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main
      className="jobs"
      onClick={() => isSidebarOpened && dispatch(toggleSidebar(false))}
    >
      <h1 className="jobs__label">فرصت شغلی</h1>

      <ul className="kards kards--jobs">
        <li className="kards__card kards__card-job">
          <img
            src="/img/Mesadetrabajo.png"
            alt="designer"
            className="jobs__img"
          />
          <h1 className="jobs__title">طراح</h1>
        </li>
        <li className="kards__card kards__card-job">
          <img src="/img/20945975.jpg" alt="driver" className="jobs__img" />
          <h1 className="jobs__title">راننده</h1>
        </li>
        <li className="kards__card kards__card-job">
          <img src="/img/19197512.jpg" alt="marketer" className="jobs__img" />
          <h1 className="jobs__title">بازاریاب</h1>
        </li>
        <li className="kards__card kards__card-job">
          <img src="/img/20943705.jpg" alt="call" className="jobs__img" />
          <h1 className="jobs__title">کالسنتر</h1>
        </li>
        <li className="kards__card kards__card-job">
          <img src="/img/19199535.jpg" alt="keeper" className="jobs__img" />
          <h1 className="jobs__title">انبار دار</h1>
        </li>
      </ul>
      <div className="jobs__upload">
        <span className="jobs__upload-label">
          درصورت تمایل به همکاری با ما در زمینه فرصت های شغلی ذکر شده ، فرم
          درخواست را دانلود کرده و پس از تکمیل برای ارسال به اتوماسیون اداری با
          پشتیبانی هماهنگ کنید
        </span>
        <a
          className="jobs__upload-download"
          href="./files/رزومه خام نهایی.doc"
          download="رزومه خام نهایی.doc"
        >
          <img
            className="jobs__upload-img"
            src="/img/download-svgrepo-com.svg"
            alt=""
          />
          <h2>دانلود فرم درخواست</h2>
        </a>

        <p className="jobs__upload-label"></p>
      </div>
      <Link
        to="/order"
        className="main__Send-package"
      >
        <img className="main__Send-package-img" src="/img/postfix.png" alt="" />
        <h4>ارسال بسته</h4>
      </Link>
    </main>
  );
};

export default Job;
